export const environment = {
    production: false,
    CORBADO_PROJECT_ID: 'pro-5463759675628142986',
    API_ENDPOINT: 'https://dev101.arthawell.com',
};
